<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left;display:block" id="consBillDiv" >
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Recharge Prepaid Meter</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Recharge Prepaid Meter</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
          <!-- <br>
          <p style="color:red">We are facing technical issue with payment gateway. Kindly make your recharge at sub division. <br> Sorry for the inconvenience</p> -->


        <b-row>
          <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
          </b-col>
          <b-col col cols="8" sm="8" md="8" lg="4">
              <b-form-input type="text" maxlength="12" id="consNo" value=""  placeholder="Enter Prepaid Consumer Number" trim required />
          </b-col>
          <b-col col cols="4" sm="3" md="3" lg="1">
                <b-button id="submitBtn" @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                  <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                </b-button>

          </b-col>
        </b-row>

    </br>
        <div id="BillDetails" class="billDetails">
          <b-row>
            <b-col cols=12>
                <span class="heading">Bill Details</span>
            </b-col>
          </b-row>
          <hr/>

          <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Consumer Name : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="consName"></span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Location : </span>
          </b-col>
          <b-col cols="12" sm="3" md="3" lg="3">
            <span class="" id="subDiv"></span>
          </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Meter No : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="meterNo"></span>
          </b-col>
          <!-- <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Category : </span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="" id="category"></span>
          </b-col> -->
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Amount <span class="text-danger">*</span> :    </span>
          </b-col>
            <b-col cols="12" sm="2" md="2" lg="2">
              <b-form-input type="number" id="amount" placeholder="Recharge  Amount" trim ></b-form-input>
            </b-col>
        </b-row>
        <b-row class="paddingRow">
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Mobile No <span class="text-danger">*</span> :</span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <b-form-input type="number" id="mobileNo" placeholder="Mobile No for E-Receipt" trim />
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <span class="label">Email ID :</span>
          </b-col>
          <b-col cols="12" sm="2" md="2" lg="2">
            <b-form-input type="email" id="emailId" placeholder="Email ID for E-Receipt" trim />
          </b-col>
        </b-row>
      <br>
        <b-row>
              <b-col cols="12"sm="3" md="3" lg="3" offset-sm="4" offfset-md="4" offset-lg="4">

                  <b-button block squared variant="primary" @click="payNow()">
                   <b-icon icon="credit-card" animation=""  >  </b-icon> PAY NOW
                 </b-button>

              </b-col>
            </b-row>
          </div>
      </div>

  </b-container>
  <b-container fluid style="padding-top: 100px;text-align:left;display:none" id="billdeskRequestDiv">
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
    <br><br>
  <b-row id="spinner" style="display:block">
    <b-col cols=12 align="center">
      <h3 class="">Processing Payment Request...</h3>
      <br><br>
        <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
      <br><br><br>
       <h5 style="color:red">Please do not press back or refresh button</h5>
    </b-col>
  </b-row>
  <b-row id="errorDiv" style="display:none">
    <b-col cols=12 align="center">
      <h2 style="color:red" id="errorMsg"></h2>
      <br><br>
      <b-button onclick="window.location.reload();">Go Back</b-button>
    </b-col>
  </b-row>
</b-container>
<br><br>
</b-overlay>

<form :action = "reqUrl" method="post" id="pgrequest" hidden>
    <input type="" name="msg" :value = "messageToSend" hidden >
    <input type="submit" id="submit" value="submit" hidden >
</form>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg"> DEMO </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var consNo="";
var sdCode = "";


//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      show: false,
      message : [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
      reqUrl : "",
      messageToSend : "",

    }
  },

  methods: {
    showDetails() {
      consNo = document.getElementById("consNo").value;
      var parent =this;
    if (consNo.toString().length==0)
        {
          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        }
        else{
          this.show= true;
          axios.post(this.$urlCommon+ '/api/web/prepaidRecharge?consNo='+consNo)
          .then((response) => {
            console.log(response.data);

            var data=response.data;
            var msg=data.isValid;

            if(msg=="Valid") {
              sdCode = data.sdCode;
              document.getElementById("consName").innerHTML=data.consumerName;
              document.getElementById("subDiv").innerHTML=data.address;
              document.getElementById("meterNo").innerHTML=data.meterNo;
              // document.getElementById("category").innerHTML=data.categoryName;
              parent.show= false;
              document.getElementById("BillDetails").classList.add("showBillDetails");
            }
            else
            {
              parent.show= false;
              parent.$bvModal.show("model");
              document.getElementById("msg").innerHTML=data.errorcode;
              document.getElementById("BillDetails").classList.remove("showBillDetails");
            }
      })
      .catch((e) => {
        parent.show= false;
        parent.$bvModal.show('model');
        document.getElementById("msg").innerHTML="Sorry, Please Try Again Later";
        console.log("Caught :::::::::::::::", e.message);

    })

        }
      },

    payNow()
    {

      var mobileNo = document.getElementById("mobileNo").value;
      var emailId = document.getElementById("emailId").value;
      var amountPaid = document.getElementById("amount").value;


      console.log(parseInt(amountPaid)%100);

      if (emailId=="")
      {
        emailId="NA";
      }

      if (amountPaid<10 || amountPaid>5000 )
          {
            this.$bvToast.toast('Enter Amount between Rs. 10.00 - Rs. 5000.00 !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("amount").focus();
            return
          }
          if ((parseInt(amountPaid)%100)!= 0 )
              {
                this.$bvToast.toast('Enter Amount Multiple of 100 !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                })
                document.getElementById("amount").focus();
                return
              }
      if (mobileNo.length!=10)
          {
            this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return
          }

    //  window.location.href="/website/BilldeskRequestPrepaid?consNo="+this.consumerNo+"&subDiv="+this.subDiv+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&emailId="+emailId;

    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent=this;
    axios.post( this.$urlCommon+'/api/onlineprepaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode+"&amountPaid="+amountPaid+"&mobileNo="+mobileNo+"&email="+emailId)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var status=response.data.message;

      if(status=="00") {
        parent.reqUrl = data.action;
        parent.messageToSend= data.msg;
        setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
      }
      else
      {

        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=parent.message[parseInt(status)];

      }


    })
    .catch((e) => {
    console.log("Caught", e);
    this.show= false;
    this.$bvModal.show("model");
    document.getElementById("msg").innerHTML=e;
    document.getElementById("BillDetails").classList.remove("showBillDetails");
  })

    },
    closeModal(){
      this.$bvModal.hide('model')
    }


  }
}


</script>

<style scoped="true">
td{
  padding:0.7rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.billDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
    padding: 1rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingRow{
  padding:0.7rem;
}
.paddingLeft30px{
  padding-left: 30px;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
}
</style>
